export default class ApiRequestError extends Error {
  constructor (errorNumber, messages, result, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(1 === messages.length?messages[0].type:"MULTIPLE_ERRORS", ...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiRequestError);
    }

    this.constructor = ApiRequestError;
    this.__proto__   = ApiRequestError.prototype;
    this.name = 'ApiRequestError';
    this.errorNumber = errorNumber;
    this.messages = messages;
    this.result = result;
  }
}



// WEBPACK FOOTER //
// ./src/components/ApiRequestError.js